/* eslint-disable no-nested-ternary */
import {
  Divider, Flex,
  Text
} from "@mantine/core";
import React from "react";
import HeIcon from "../../../../../assets/images/heSmP.svg?react";

interface SlackPreviewProps {
  signal: any;
  traits: any;
  metrics: any;
}

const SlackPreview: React.FC<SlackPreviewProps> = ({ signal, traits, metrics }: any) => (
  <Flex gap={12} className="p-5 pl-3" align="start">
    <HeIcon className=" w-6 h-6 mt-0.5" />
    <div>
      <div className="mb-1">
        <Flex align="center" gap="xs" className="mb-1">
          <Text ta="left" fw={700}>Hyperengage</Text>
          <Text ta="left" className="bg-gray-200 text-gray-700 p-1 py-0 text-xs font-semibold rounded-md">App</Text>
        </Flex>
        <Text ta="left" fw={600}>{signal?.name}</Text>
        <Text size="sm" className="mb-1">
          Here are 1 of
          {" "}
          {signal?.responseData?.length}
          {" "}
          {signal?.entity_relation}
          {" "}
          that match.
        </Text>
        <Divider className="my-2" />
      </div>
      <div>
        {[...signal.metrics, ...signal.selected_fields]?.length > 0
          ? [...signal.metrics, ...signal.selected_fields].map((val: any) => (
            <p className="mb-1 text-xs">
              <strong>
                {{ ...traits, ...metrics }[val]?.display_name}
                :
              </strong>
              {" "}
              {signal?.responseData?.[0]?.[val] ? (signal?.responseData?.[0]?.[val]?.value ? signal?.responseData?.[0]?.[val]?.value : signal?.responseData?.[0]?.[val]) : "-"}
            </p>
          )) : (
            <Text size="sm" className="text-gray-500">
              No data to show
            </Text>
          )}
      </div>
    </div>
  </Flex>
);

export default SlackPreview;
